import axiosClient from "api/axios_client.js";

const apiTimezoneDirectory = {
  create: (payload) => axiosClient.post(`/directories/system-master/timezone/create`, payload),
  update: (id, payload) => axiosClient.put(`/directories/system-master/timezone/update/${id}`, payload),
  getById: (id) => axiosClient.get(`/directories/system-master/timezone/get-by-id/${id}`),
  updateStatus: (payload) => axiosClient.post(`/directories/system-master/timezone/update-status`, payload),
  getAllTimezone: (payload) => axiosClient.post(`/directories/system-master/timezone/get-all`, payload),
  delete: (ids) => axiosClient.delete(`/directories/system-master/timezone/delete`, { data: { ids } }),
};

export default apiTimezoneDirectory;
